import { getTablePermissions } from "@/lib/permissions";
import type { UserRoleType } from "@/types/auth";

export const getInvestigationTableConfig = (userRoles: UserRoleType[] | null, displayNames?) => {
  const permissions = getTablePermissions(userRoles, "investigations");

  return {
    entityName: "Investigation",
    entityNamePlural: "Investigations",

    tableConfig: {
      ignore: ["", "tenant_id", "meta_data", "comments", "history"],
      readonly: ["id", "created_at", "incidents"],
      validators: {},
      headerFunc: (name: string) => {
        switch (name) {
          case "id":
            return `${displayNames?.investigations?.name ?? "Investigation"} Id`;
          default:
            return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        }
      },
      cellTextCallback: (value: any, key: string) => {
        if (value == null) return "";
        if (key === "id") return value.toString().slice(0, 6).toUpperCase();
        if (key === "incidents" && Array.isArray(value)) return value.map((i: any) => i.name).join(", ");
        return typeof value === "string" ? value : JSON.stringify(value);
      },
      dataTypes: {
        created_at: "date",
        status: {
          type: "enum",
          options: [
            { value: "PENDING", color: "pending" },
            { value: "IN PROGRESS", color: "pending" },
            { value: "COMPLETED", color: "complete" },
          ],
        },
        incidents: {
          type: "array" as const,
          picker: "incident" as const,
          chipColor: "#DC3545",
          options: [],
        },
      },
    },
    filterChoices: [
      {
        name: "id",
        kind: "text" as const,
        displayName: `${displayNames?.investigations?.name ?? "Investigation"} Id`,
        menus: ["filter", "visible"] as const,
      },
      { name: "description", kind: "text", menus: ["filter", "visible"] as const },
      { name: "status", kind: "text", menus: ["filter", "visible"] as const },
      { name: "incident_id", kind: "text", menus: ["filter", "visible"] as const },
      { name: "incidents", kind: "array" as const, displayName: "Incidents", menus: ["filter", "visible"] as const },
      { name: "created_at", kind: "date", menus: ["filter", "visible", "orderby"] as const },
    ],
    ...permissions,
    storageKey: "investigation_flyout",
  };
};
